// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34noi","left":"styles_left__1SFqN"};